module.exports = __WEBPACK_EXTERNAL_MODULE_node_fetch__;


//////////////////
// WEBPACK FOOTER
// external "null"
// module id = node-fetch
// module chunks = 0